import { render } from "./Psychiatry.vue?vue&type=template&id=67c182d7&scoped=true"
import script from "./Psychiatry.vue?vue&type=script&lang=ts"
export * from "./Psychiatry.vue?vue&type=script&lang=ts"

import "./Psychiatry.vue?vue&type=style&index=0&id=67c182d7&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-67c182d7"

export default script